import React from 'react';
import { Globe } from 'lucide-react';

export default function GetTheApp() {
  return (
    <section className="bg-[#f5f5f3] py-24 md:py-28">
      <div className="max-w-[1100px] mx-auto px-5 md:px-8">
        <div className="rounded-[32px] bg-white p-8 md:p-14 ring-1 ring-black/[0.05] shadow-[0_30px_80px_-40px_rgba(15,15,16,0.25)] flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="max-w-md">
            <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">GET THE APP</span>
            <h3 className="mt-3 text-[28px] md:text-[36px] font-semibold tracking-[-0.02em] text-[#0f0f10]">
              Coming soon to Play Store and App Store.
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full md:w-auto">
            <StoreBtn small="GET IT ON" big="Google Play" />
            <StoreBtn small="DOWNLOAD ON THE" big="App Store" />
            <StoreBtn small="USE IT" big="On the web" icon={Globe} active />
          </div>
        </div>
      </div>
    </section>
  );
}

function StoreBtn({ small, big, icon: Icon, active }) {
  return (
    <button
      className={`flex items-center justify-center gap-3 rounded-2xl px-5 py-3.5 text-left transition-colors min-w-[180px] ${
        active
          ? 'bg-[#FF6A1A] hover:bg-[#ff5a05] text-white'
          : 'bg-[#0f0f10] hover:bg-[#222] text-white'
      }`}
    >
      {Icon ? <Icon size={22} /> : <PhoneBoxIcon />}
      <div>
        <div className="text-[9.5px] font-semibold tracking-[0.14em] opacity-80">{small}</div>
        <div className="text-[15px] font-semibold leading-tight">{big}</div>
      </div>
    </button>
  );
}

function PhoneBoxIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
      <path d="M17 2H7C5.34 2 4 3.34 4 5v14c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zM7 4h10c.55 0 1 .45 1 1v12H6V5c0-.55.45-1 1-1zm5 16c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5z" />
    </svg>
  );
}
